import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const StoriesRail = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    api.get("/stories").then((r) => setStories(r.data)).catch(() => {});
  }, []);

  if (!stories.length) return null;

  return (
    <section className="py-12 md:py-16 bg-cream" data-testid="stories-rail-section">
      <div className="rieave-container">
        <div className="flex justify-center">
          <div
            className="flex gap-6 md:gap-10 overflow-x-auto pb-4 px-4 hide-scrollbar max-w-full"
            data-testid="stories-rail"
          >
            {stories.map((s, i) => {
              const Wrapper = s.link ? Link : "div";
              const props = s.link ? { to: s.link } : {};
              return (
                <Wrapper
                  key={s.id}
                  {...props}
                  className="flex flex-col items-center gap-3 cursor-pointer group animate-fade-up flex-shrink-0 p-1"
                  style={{ animationDelay: `${i * 80}ms` }}
                  data-testid={`story-${(s.title || "").toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="relative">
                    <div
                      className="w-[78px] h-[78px] md:w-[96px] md:h-[96px] rounded-full p-[3px] transition-transform duration-500 ease-out group-hover:scale-[1.04]"
                      style={{ background: "linear-gradient(135deg, #F3D6E2, #E6E2F5)" }}
                    >
                      <div className="w-full h-full rounded-full bg-cream p-[2px]">
                        <div className="w-full h-full rounded-full overflow-hidden relative">
                          <img
                            src={s.image_url}
                            alt={s.title}
                            className="w-full h-full object-cover transition-transform duration-700 ease-out scale-[1.05] group-hover:scale-110"
                            loading="lazy"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="font-body text-xs md:text-sm tracking-wide text-center whitespace-nowrap text-charcoal/80 group-hover:text-rose transition-colors">
                    {s.title}
                  </span>
                </Wrapper>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoriesRail;
